module.exports = __webpack_public_path__ + "static/googlePlay-7db28d910aadc15cf02378590710d6b2.svg";